<template>
  <div class="brokerage_container">
    <van-nav-bar title="佣金" left-arrow @click-left="onClickLeft" />
    <div class="header">
      <div class="brokerage_title">佣金金额</div>
      <div class="brokerage_price">
        <div style="margin-bottom: 3vw;margin-right: 1vw;">¥</div>
        <div class="totalPrice">{{totalPrice}}</div>
      </div>
    </div>
    <div class="dec">
      <p>资金明细</p>
      <div>
        <span>进账 ¥{{ formatPrice(entryAmount) }}</span>
        <span style="margin-left:1vw;">提现 ¥{{ formatPrice(withdrawal) }}</span>
      </div>
    </div>
    <div class="noOrders" v-if="list.length == 0">
      <div v-if="!firstLoading">你还没有订单哦...</div>
      <van-loading v-else type="spinner" />
    </div>
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      style="overflow: auto; height: calc(100% - 56vw);"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="到底啦~"
        @load="onLoad"
        v-if="list.length > 0"
      >
        <div class="main">
          <div class="list" id="list" v-for="item in list" :key="item.id">
            <div class="flex">
              <div class="image">
                <img src="../../../assets/images/brokerage_list.png" alt />
              </div>
              <div>
                <div class="list_l">{{item.tag}}</div>
                <div class="shop">
                  <span class="black">{{item.logTime}}</span>
                </div>
              </div>
            </div>

            <div>
              <div class="list_r" v-if="item.percentage>=0">+ {{formatPrice(item.percentage)}}</div>
              <div class="list_r" v-if="item.percentage<0">{{formatPrice(item.percentage)}}</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Toast, Dialog, List, PullRefresh, NavBar, Loading } from "vant";
import { mapGetters, mapActions } from "vuex";
import { parseTime } from "../../util/date.js";
import service from "../../api/employeePage/index";
export default {
  name: "qecode",
  data() {
    return {
      totalPrice: 0,
      list: [],
      orderPrice: 50,
      page: 1,
      pageSize: 10,
      reachBottom: false,
      loading: false,
      finished: false,
      refreshing: false,
      firstLoading: true,
      entryAmount: 0,
      withdrawal: 0
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Loading.name]: Loading
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.page = 1;
    this.pageSize = 10;
    this.init();
  },
  methods: {
    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    onLoad() {
      this.page++;
      if (this.refreshing) {
        this.refreshing = false;
      }
      this.getList().then(list => {
        list.employeeBalanceRecordList.map(i => {
          i.logTime = parseTime(i.logTime);
        });
        this.list = this.list.concat(list.employeeBalanceRecordList);
        this.loading = false;
        if (list.employeeBalanceRecordList.length < 10) {
          this.finished = true;
        }
      });
    },
    init() {
      this.totalPrice = this.$route.query.price;
      this.firstLoading = true;
      this.loading = true;
      this.getList().then(list => {
        this.entryAmount = list.income;
        this.withdrawal = list.outcome;
        list.employeeBalanceRecordList.map(i => {
          i.logTime = parseTime(i.logTime);
        });
        this.loading = false;
        this.list = list.employeeBalanceRecordList;
        this.firstLoading = false;
      });
    },
    getList() {
      return new Promise((resolve, reject) => {
        service
          .list(this.page, this.pageSize)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject();
          });
      });
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.loading = true;
      this.list = [];
      this.getList().then(list => {
        list.employeeBalanceRecordList.map(i => {
          i.logTime = parseTime(i.logTime);
        });
        this.list = list.employeeBalanceRecordList;
        if (list.employeeBalanceRecordList.length < 10) {
          this.finished = true;
          this.loading = false;
        }
      });
      this.refreshing = true;
      this.onLoad();
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.brokerage_container {
  background: #fff;
  height:calc(100% - 48px) ;
  .van-nav-bar {
    background: #fd6a5f;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  @{deep} .van-nav-bar .van-icon {
    color: #fff;
  }
  @{deep} .van-nav-bar__title {
    color: #fff;
  }

  .dec {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 17px;
    font-size: 13px;
    background: #f7f7f7;
    border-top: 1px solid #f7f7f7;
    border-bottom: 1px solid #f7f7f7;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .brokerage_price {
    display: flex;
    font-size: 20px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
  }
}
.header {
  height: 120px;
  background: #fd6a5f;
  text-align: center;
  color: #fff;
  .brokerage_title {
    height: 50px;
    line-height: 50px;
  }
  .totalPrice {
    height: 65px;
    font-size: 36px;
  }
}
.main {
  margin: 1vw 0;
  background: #fff;
}
.list {
  display: flex;
  padding: 0.5rem 1rem 0.5rem 0.1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.01rem solid rgba(230, 230, 230, 1);
  margin: 0 0.15rem;
  .image {
    width: 32px;
    height: 32px;
    padding: 0 3vw;
  }
  .shop {
    color: #b3b3b3;
    font-size: 12px;
  }
  .list_r {
    height: 40px;
    line-height: 40px;
    text-align: right;
    font-weight: bold;
  }
  .list_l {
    height: 40px;
    line-height: 40px;
  }
}
</style>